const colors = {
  confirmColor: '#c0f1d1',
  rejectColor: '#f3afaf'
};


export default colors;
